/**
 * 면허 인증 공통 문구.
 * 가입 폼·내 정보 수정·면허 인증 신청 화면이 같은 문구를 써야 하므로 한 곳에서 관리한다.
 */

/**
 * 면허번호를 입력하면 생년월일이 필수다 — 면허 진위 확인에 성명·생년월일·면허번호가 함께 필요하기 때문.
 * 서버(400) 응답 문구와 동일하게 유지할 것.
 */
export const LICENSE_BIRTHDAY_REQUIRED_MESSAGE = '면허번호를 입력하면 생년월일도 입력해 주세요';

/**
 * 면허 이미지 누락 문구 — 서버(400, LicenseVerificationService.IMAGE_REQUIRED_MESSAGE) 응답 문구와 동일하게 유지할 것.
 */
export const LICENSE_IMAGE_REQUIRED_MESSAGE = '면허증 사진 또는 정부24 면허(자격)증명서를 첨부해 주세요';

/**
 * 면허 인증 신청 화면의 필수 동의 문구(개인정보 수집·이용 근거).
 * 기획 확정 문구 그대로이며 임의로 요약·의역하지 않는다.
 */
export const LICENSE_CONSENT_TITLE = '[필수] 면허 인증을 위한 면허증 이미지 수집·이용 동의';

export const LICENSE_CONSENT_DETAIL =
    '수집 항목: 면허증(또는 면허증명서) 이미지, 성명, 생년월일, 면허번호 / ' +
    '이용 목적: 치과 종사자 면허 진위 확인(인증 배지 부여) 및 회원정보(성명·생년월일·면허번호) 정정에 한함 / ' +
    '보유 기간: 승인 건은 사후 확인을 위해 승인 후 30일 보관 뒤 파기, 반려 건은 즉시 파기, 검수 전 30일 경과 시 자동 파기. ' +
    '승인 시 성명·생년월일·면허번호를 회원정보에 반영하고 인증 결과와 함께 보관하며, 회원 탈퇴 시 삭제 / ' +
    '거부 시 면허 인증 및 인증 회원 전용 기능(내 급여 위치 등) 이용 불가';

/**
 * "자세히" 안의 자동 판독 안내 — 처리방침 제5조의2(국외 이전)·제7조의2(자동화된 결정)와 내용을 맞출 것.
 * 2026-09-22 동의 상세에 추가 확정.
 */
export const LICENSE_AUTO_CHECK_NOTICE =
    '자동 판독: 빠른 인증을 위해 이미지를 자동 판독(Anthropic, 미국)해요. ' +
    '이름·생년월일·면허번호가 모두 맞으면 바로 인증되고, 아니면 관리자가 확인해요.';

/** 자동 판독 제외 체크 라벨 — 처리방침 제5조의2 의 거부 방법 문구와 같게 유지할 것 */
export const LICENSE_AUTO_CHECK_OPT_OUT_LABEL = '자동 판독 없이 관리자가 직접 확인해 주세요';
